import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminRouteNames } from '@core/presentation';
import { HomeContainer } from '@modules/shared/presentation';

import { AdminMainDashboardPage } from './index';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard/home', pathMatch: 'full' },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: '',
    component: AdminMainDashboardPage,
    children: [
      {
        path: AdminRouteNames.home,
        component: HomeContainer,
      },
      {
        path: AdminRouteNames.approve,
        loadChildren: () =>
          import('../../../regular-user/approves/admin-approve.module').then(
            (m) => m.AdminApproveModule
          ),
      },
      {
        path: AdminRouteNames.requests,
        loadChildren: () =>
          import('../../../regular-user/requests/admin-request.module').then(
            (m) => m.AdminRequestsModule
          ),
      },
      {
        path: AdminRouteNames.history,
        loadChildren: () =>
          import('../../../regular-user/history/admin-history.module').then(
            (m) => m.AdminHistoryModule
          ),
      },
      {
        path: AdminRouteNames.profile,
        loadChildren: () =>
          import('../../../regular-user/profile/admin-profile.module').then(
            (m) => m.AdminProfileModule
          ),
      },
      {
        path: AdminRouteNames.users,
        loadChildren: () =>
          import('../../../company-manager/users/admin-users.module').then(
            (m) => m.AdminUsersModule
          ),
      },

      {
        path: AdminRouteNames.clients,
        loadChildren: () =>
          import('../../../company-manager/clients/admin-clients.module').then(
            (m) => m.AdminClientsModule
          ),
      },
      {
        path: AdminRouteNames.requestType,
        loadChildren: () =>
          import(
            '../../../company-manager/requests-type/admin-request-type.module'
          ).then((m) => m.AdminRequestTypeModule),
      },

      {
        path: AdminRouteNames.membership,
        loadChildren: () =>
          import(
            '../../../company-manager/membership/admin-membership.module'
          ).then((m) => m.AdminMembershipModule),
      },
      // {
      //   path: AdminRouteNames.superAdmin,
      //   loadChildren: () =>
      //     import(
      //       '../../../super-admin/superadmin-home/superadmin-home.module'
      //     ).then((m) => m.SuperAdminHomeModule),
      // },
      {
        path: AdminRouteNames.company,
        loadChildren: () =>
          import('../../../super-admin/company/admin-company.module').then(
            (m) => m.AdminCompanyModule
          ),
      },
      {
        path: AdminRouteNames.subscriptions,
        loadChildren: () =>
          import(
            '../../../super-admin/subscription/admin-subscription.module'
          ).then((m) => m.AdminSubscriptionModule),
      },
      {
        path: AdminRouteNames.changePassword,
        loadChildren: () =>
          import(
            '../../../super-admin/change-password/change-password.module'
          ).then((m) => m.ChangePasswordModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminCoreRoutingModule {}
